import React from 'react'
import { css, cx } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import { H2 } from '../../../legacy-design-system/heading'
import { theme } from '@contrast-security-inc/design-system-foundations'
import {
  VrApplicationAggregations,
  VrApplicationFilter,
  VrFilterManagerChildProps
} from './filters'
import { ValueReportingDashboardProps } from '../vr-main'
import { ToggleToOldDashboard } from '../../dashboard-toggle'
import { ErrorBoundary } from '../../../legacy-design-system/error-boundary/error-boundary'
import { theme as deprecatedTheme } from '../../../styled'

const cssHeaderPanel = css`
  background: white;
  border: solid 1px ${theme.color.neutral30};
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
`

const cssTitleHeader = css`
  margin: 0 0 ${deprecatedTheme.space[1]}px 0;
  font-family: ${deprecatedTheme.fontFamilies.primary};
  font-weight: bold;
`

const cssFiltersContainer = css`
  display: flex;
`

const cssRow = css`
  display: flex;
  flex-direction: row;
  width: 100%;
`

const Row = ({ children }) => <div className={cssRow} children={children} />

export function VrHeader({
  organizationUuid,
  aggregationSelections,
  selectedFacets,
  ratingsLoading,
  totalApplications,
  onGroupToggle,
  onMultiGroupToggle,
  onOptionToggle,
  onAggregationCategoriesClear,
  onBackToOldDashboard
}: VrFilterManagerChildProps<VrApplicationAggregations> &
  Pick<
    ValueReportingDashboardProps,
    'organizationUuid' | 'onBackToOldDashboard'
  > & {
    ratingsLoading: boolean
    totalApplications?: number
  }) {
  return (
    <div className={cssHeaderPanel}>
      <Row>
        <H2 className={cssTitleHeader}>
          <FormattedMessage id="title_securitySummary" />
        </H2>
      </Row>
      <Row>
        <div
          className={cx(
            cssFiltersContainer,
            css`
              flex: 1;
            `
          )}
        >
          <ErrorBoundary>
            <VrApplicationFilter
              organizationUuid={organizationUuid}
              aggregationSelections={aggregationSelections}
              selectedFacets={selectedFacets}
              ratingsLoading={ratingsLoading}
              totalApplications={totalApplications}
              onGroupToggle={onGroupToggle}
              onOptionToggle={onOptionToggle}
              onAggregationCategoriesClear={onAggregationCategoriesClear}
              onMultiGroupToggle={onMultiGroupToggle}
            />
          </ErrorBoundary>
          {/* TODO: Uncomment this with https://contrast.atlassian.net/browse/VR-57 */}
          {/* <VrTimeFilter /> */}
        </div>
        <div
          className={css`
            flex: 1;
            text-align: right;
          `}
        >
          <ToggleToOldDashboard onClick={onBackToOldDashboard} />
        </div>
      </Row>
    </div>
  )
}
